import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const LoadingBackdrop = (props) => {
    return (
        <Backdrop
            sx={
                {
                    color: '#fff',
                    backdropFilter: 'blur(7px)',
                    zIndex: (theme) => theme.zIndex.drawer + 1
                }
            }
            open={props.open}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, px: 3 }}>
                {props.icon}
                {props.message && (
                    <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '16px', textAlign: 'center', maxWidth: 360 }}>
                        {props.message}
                    </Typography>
                )}
            </Box>
        </Backdrop>
    )
}

export default LoadingBackdrop